
import Vue from 'vue';
import SearchTitle from './components/SearchTitle.vue';
import SearchMessage from './components/SearchMessage.vue';
import SearchHits from './components/SearchHits.vue';
import SearchFilters from './components/SearchFilters.vue';
import SearchField from './components/SearchField.vue';
import SearchType from './components/SearchType.vue';
import SearchFilterRemover from './components/SearchFilterRemover.vue';
import { IState } from './store/state';

// Interfaces for component typechecking!
interface AppData {

}

interface AppMethods {

}

interface AppComputed {
	loading: boolean
}

interface AppProps {

}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'app',
	computed: {
		loading() {
			return (this.$store.state as IState).loading;
		}
	},
	components: {
		SearchTitle,
		SearchField,
		SearchFilters,
		SearchHits,
		SearchMessage,
		SearchType,
		SearchFilterRemover,
	}
})
